import { ReactComponent } from "./expand-more.svg";

const ExpandMoreIcon = () => <ReactComponent />;

export default ExpandMoreIcon;
